import React from "react";

function CoatingMachine() {
  return (
    <>
      <style>{`
      .technical-spec-section {
        margin: 40px 0;
        overflow-x: auto;
      }
      .technical-spec-section h4 {
        font-family: 'Oxygen', sans-serif;
        font-weight: bold;
        font-size: 24px;
        color: #000;
        margin-bottom: 20px;
      }
      .table {
        width: 100%;
        border-collapse: collapse;
        background: white;
      }
      .table-bordered {
        border: 1px solid #ddd;
      }
      .table-bordered td {
        border: 1px solid #ddd;
        padding: 12px 15px;
        font-size: 14px;
      }
      .table tbody tr:nth-child(even) {
        background-color: #f2f2f2;
      }
      .table td:first-child {
        font-weight: 600;
        width: 40%;
      }
    `}</style>

      <main id="primary" className="site-main">
        <div className="space-for-header"></div>

        {/* Breadcrumb Section */}
        <section
          className="tj-page-header section-gap-x"
          data-bg-image="assets/images/bg/pheader-bg.webp"
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="tj-page-header-content text-center">
                  <h1 className="tj-page-title">Coating Machine</h1>
                  <div className="tj-page-link">
                    <span><i className="fa-solid fa-home"></i></span>
                    <span><a href="/">Home</a></span>
                    <span><i className="fa-solid fa-arrow-right"></i></span>
                    <span><span>Coating Machine</span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div 
            className="page-header-overlay" 
            data-bg-image="assets/images/shape/pheader-overlay.png">
          </div>
        </section>

        {/* MAIN CONTENT */}
        <section className="tj-blog-section section-gap slidebar-stickiy-container">
          <div className="container">
            <div className="row row-gap-5">

              {/* LEFT SIDE CONTENT */}
              <div className="col-lg-8">
                <div className="post-details-wrapper">

                  {/* MAIN IMAGE */}
                  <div 
                    className="blog-images wow fadeInUp" 
                    data-wow-delay=".1s"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <div className="col-sm-6">
                      <img 
                        src="assets/images/SD_PHRMA_ALL_MIX _JPGS/27.png" 
                        alt="Coating Machine" 
                      />
                    </div>
                  </div>

                  <h2 className="title title-anim">Coating Machine</h2>

                  <div className="blog-text">
                    <p className="wow fadeInUp" data-wow-delay=".3s">
                      The Coating Machine is designed for film and sugar coating 
                      of tablets. Its high-efficiency perforated pan ensures uniform 
                      coating distribution, while maintaining gentle tumbling of tablets.
                    </p>

                    <p className="wow fadeInUp" data-wow-delay=".4s">
                      With stainless steel construction, powerful exhaust system, 
                      precision spray nozzles, and controlled drying, it delivers 
                      superior coating quality and consistency.
                    </p>
                  </div>

                  {/* EXTRA IMAGES */}
                  <div className="images-wrap">
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="image-box wow fadeInUp" data-wow-delay=".3s">
                          <img 
                            src="assets/images/SD_PHRMA_ALL_MIX _JPGS/27.png" 
                            alt="Coating Machine Side" 
                          />
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="image-box wow fadeInUp" data-wow-delay=".5s">
                          <img 
                            src="assets/images/SD_PHRMA_ALL_MIX _JPGS/28.png" 
                            alt="Coating Machine Closeup" 
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* TECHNICAL SPECIFICATIONS */}
                  <div className="technical-spec-section">
                    <h4>Technical Specification</h4>

                    {/* TABLE 1 */}
                    <h5 style={{ marginTop: "20px" }}>Small Models</h5>
                    <table className="table table-bordered">
                      <tbody>

                        <tr>
                          <td>Model</td>
                          <td>DPM-CM-12</td>
                          <td>DPM-CM-24</td>
                          <td>DPM-CM-36</td>
                        </tr>

                        <tr>
                          <td>Pan Diameter</td>
                          <td>12 inch</td>
                          <td>24 inch</td>
                          <td>36 inch</td>
                        </tr>

                        <tr>
                          <td>Working Capacity</td>
                          <td>1–2 kg</td>
                          <td>8–12 kg</td>
                          <td>25–40 kg</td>
                        </tr>

                        <tr>
                          <td>Motor</td>
                          <td>0.25 HP</td>
                          <td>0.5 HP</td>
                          <td>1 HP</td>
                        </tr>

                        <tr>
                          <td>Exhaust Blower</td>
                          <td>0.5 HP</td>
                          <td>1 HP</td>
                          <td>1.5 HP</td>
                        </tr>

                      </tbody>
                    </table>

                    {/* TABLE 2 */}
                    <h5 style={{ marginTop: "20px" }}>Large Models</h5>
                    <table className="table table-bordered">
                      <tbody>

                        <tr>
                          <td>Model</td>
                          <td>DPM-CM-48</td>
                          <td>DPM-CM-60</td>
                          <td>DPM-CM-72</td>
                        </tr>

                        <tr>
                          <td>Pan Diameter</td>
                          <td>48 inch</td>
                          <td>60 inch</td>
                          <td>72 inch</td>
                        </tr>

                        <tr>
                          <td>Working Capacity</td>
                          <td>50–75 kg</td>
                          <td>80–120 kg</td>
                          <td>140–200 kg</td>
                        </tr>

                        <tr>
                          <td>Motor</td>
                          <td>2 HP</td>
                          <td>3 HP</td>
                          <td>5 HP</td>
                        </tr>

                        <tr>
                          <td>Exhaust Blower</td>
                          <td>2 HP</td>
                          <td>3 HP</td>
                          <td>5 HP</td>
                        </tr>

                      </tbody>
                    </table>

                    {/* COMMON FEATURES */}
                    <h5 style={{ marginTop: "20px" }}>Construction & Features</h5>
                    <table className="table table-bordered">
                      <tbody>

                        <tr>
                          <td>Material</td>
                          <td colSpan="3">SS 304 / SS 316 Contact Parts</td>
                        </tr>

                        <tr>
                          <td>Coating Type</td>
                          <td colSpan="3">Film Coating / Sugar Coating</td>
                        </tr>

                        <tr>
                          <td>Heating</td>
                          <td colSpan="3">Electric Heaters with Controlled Airflow</td>
                        </tr>

                      </tbody>
                    </table>

                  </div>

                </div>
              </div>

              {/* RIGHT SIDEBAR */}
              <div className="col-lg-4 sidebar-container">
                <div className="tj-main-sidebar">

                  <div className="tj-sidebar-widget service-categories">
                    <h4 className="widget-title">Related Products</h4>
                    <ul>

                      <li>
                        <a href="/vibro-sifter">
                          Vibro Sifter Machine
                          <span className="icon"><i className="fa-solid fa-arrow-right"></i></span>
                        </a>
                      </li>

                      <li>
                        <a href="/mass-mixer">
                          Mass Mixer Machine
                          <span className="icon"><i className="fa-solid fa-arrow-right"></i></span>
                        </a>
                      </li>

                      <li>
                        <a href="/multi-mill">
                          Multi Mill Machine
                          <span className="icon"><i className="fa-solid fa-arrow-right"></i></span>
                        </a>
                      </li>

                    </ul>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </section>

      </main>
    </>
  );
}

export default CoatingMachine;
